/* 
    JavaScript for SHAREMED Study Site Portal
    Created on : 3 June 2021
    Author: Audrey Zammit
            Physical Oceanography Research Group
*/



// library objects
var Highcharts;

//********** VARIABLES **********//
// DOM elements
var atlas;   // the contents of the point observations panel
var sliderPts = 100;            // number of steps in time slider
var dateStart = 0;              // earliest possible date on slider
var dateEnd = 100;              // latest possible date on slider
var charts = [];                // array to contain chart objects with same size  
//charts.length = Object.keys(OptionEnum).length;  // as available options
var seriesCount = [];           // array with the number of series in each chart 
//seriesCount.length = Object.keys(OptionEnum).length;  // with same size as charts
var chartSettings = [];         // array with the settings on point observations 
//chartSettings.length = Object.keys(OptionEnum).length;  // div related to chart

// state variables
var activeSources = [];         // array of the sources selected
var timeSliderStart = [];       // array of timestamp of time slider minimum value for each selected source
                                // minimum is used on the slider
var selectedParams = [];        // array of parameters selected to be shown on chart
var currentOpt = 0;             // type of chart that is currently being generated
var openCharts = 0;             // number of charts that are open

// chart data
var queryStart, queryEnd;       // start and end time of query
var metaData = [];              // array to contain metadata about each data series
var timeLine = [];              // array of time lines used to plot the data
var dataSeries = [];            // array of arrays of data for each series

// features
var stations = [];

const OpenInfoSize = {width: 350, height: 220}; /*320,220*/
const DefaultPos = {left: '100px', top: '100px'};
const FloatingZIndex = 1000;


//********** FUNCTIONS **********//

/**
 * removes window displaying chart with selected options 
 * @param {type} seq - position of chart wrt to other charts
 */
 
 /*window.onload = function() {
    alert('onload');
    importScripts(); 

};*/


 
function closeChartDiv(seq)
{
    // remove the chart element from DOM
    var element = document.getElementById('div-chart-'+seq);
    element.parentNode.removeChild(element);
    
    // set chart object to null
    charts[currentOpt]=null;
    
    // decrement number of open charts
    openCharts--;
    
    // remove associated data structures and state variables
    seriesCount[currentOpt] = 0;
    chartSettings[seq] = null;
}

/**
 * Closes the observations panel
 */ 
 
function closeAtlasPanel()
{
    // change console button function
    $('#pt-obs-btn').attr('onclick', 'openAtlasPanel()');
	
	// remove point observations content
    AtlasContent = $('#atlas-parent').detach();
    
    // change colour and size
	$('#atlas-panel').css({opacity: 0.0, left:'0px', 
	top:'0px'});
    $('#atlas-panel').height(0).width(0);
}

/**
 * gets data and creates the content for the chart window
 * uses the stat variables to determine the source, parameters and time span
 * @param seq - sequence of this chart wrt other charts
 */
 
function createChartContent(seq)
{
    // generate the chart and add to visible charts
    charts[currentOpt] = drawChart('div-chart-'+seq+'-content', ChartTitle[currentOpt], 
                    FileName[currentOpt]);
    
    // initialise series counts for this chart
    seriesCount[currentOpt] = 0;
       
    // get data for each source and add series to the chart
    activeSources.forEach(getDataFromDatabase);
	
	//drawChart_jgplot();
}



	var jQPlotOptionsLine_params_all=
    {    	
        title:'',
	    seriesDefaults: {
        showMarker: false
    },
    axesDefaults: {
        showTicks: true,
        showTickMarks: true,
		tickOptions: {
		  showLabel: true,
          show: true,		  
          angle: 30,
          fontSize: '8pt'
        }		
    },

	 series:[{showMarker:false},


	 
	 ],
	 /*
	 	seriesDefaults: {
        show: true,     // wether to render the series.
        xaxis: 'xaxis', // either 'xaxis' or 'x2axis'.
        yaxis: 'yaxis', // either 'yaxis' or 'y2axis'.
        label: ''      // label to use in the legend for this line.
	},*/
	 //seriesColors:['#000080', '#800000'],
	 
	 
	  axes:{
        xaxis:{
          renderer:$.jqplot.DateAxisRenderer,
          tickOptions:{//formatString:'%d%m%y %H:%M',
		  showLabel: true,
          show: true,
		  formatString: '%Y',//'%d%b %H:%M',
         
		  },
		  //min:210613 14:00,
                 // tickInterval:'24 hour',
		  /*label: 'Time',*/
                  /* numberTicks: 10,*/
		   angle:30
        }
      },//axes
        
        highlighter: {
        show: true,
        sizeAdjust: 3,
      },
      cursor: {
        show: false
      },
	  
	legend: {
     show: true,
     /*placement: "insideGrid",
	 location: "sw",
	 paddingLeft:"100px",
	 marginLeft:"50px"*/
    } 

  
  };






function drawChart_jgplot_all_params(lat,lon)
{
	var thisChart;
	
	var jQPlotOptionsLine_params=
    {    	
        title:'',
	    seriesDefaults: {
        showMarker: false
    },
    axesDefaults: {
        showTicks: true,
        showTickMarks: true,
		tickOptions: {
          angle: 30,
          fontSize: '8pt'
        }		
    },
	 series:[{showMarker:false}],
	 seriesColors:['#000080', '#800000'],
	  axes:{
        xaxis:{
          renderer:$.jqplot.DateAxisRenderer,
          tickOptions:{//formatString:'%d%m%y %H:%M',
		  formatString: '%Y',//'%d%b %H:%M',
         
		  },
		  //min:210613 14:00,
                 // tickInterval:'24 hour',
		  /*label: 'Time',*/
                  /* numberTicks: 10,*/
		   angle:30
        }
      },//axes
        
        highlighter: {
        show: true,
        sizeAdjust: 3,
      },
      cursor: {
        show: false
      },
	  
	legend: {
     show: true,
     placement: 'outside',
	 marginLeft:30,
	 marginRight:10
    } 

  
   };




	
	url="/atlas/data_access/request_netCDF_all_params.php?lat="+lat+"&lon="+lon;
		var jqxhrPlotRequest = $.post(url);
	
	jqxhrPlotRequest.done(function(data){
		
		//alert(data);
		console.log(data);
		var data_plt=$.parseJSON(data);
		console.log(data_plt);
		console.log(data_plt["row"][1]);
		//alert(data_plt["row"].length)
		Points=new Array();
		Points1=new Array();
		Points2=new Array();
		Points3=new Array();
		Points4=new Array();
		
		j=0;
		while(j<data_plt["row"].length)
        {		 
			 //alert(data_plt["row"][j].date+" "+data_plt["row"][j].val);
			if(data_plt["row"][j]) 
	           {Points.push([data_plt["row"][j].date,parseFloat(data_plt["row"][j].val)]);}
		       {Points1.push([data_plt["row"][j].date,parseFloat(data_plt["row"][j].val1)]);}
			   {Points2.push([data_plt["row"][j].date,parseFloat(data_plt["row"][j].val2)]);}
			   {Points3.push([data_plt["row"][j].date,parseFloat(data_plt["row"][j].val3)]);}
			   {Points4.push([data_plt["row"][j].date,parseFloat(data_plt["row"][j].val4)]);}
		   j=j+1;
        }	

	//jQPlotOptionsLine_params.series=[{label:'years'}];
	//jQPlotOptionsLine_params_all.series=[{label:' '}];
	
		//	jQPlotOptionsLine_params_all.title="";
		jQPlotOptionsLine_params_all.series=[{label:'          without'},{label:'  Cat1 '},{label:'  Cat2  '},{label:'  Cat3  '},{label:'  Cat4  '}]
		
		//plot2=$.jqplot('chart_2', [Points_bias,Points_rmse,Points_cor,Points_nse], jQPlotOptionsLine_stat ); 
		//plot2.redraw();
	    jQPlotOptionsLine_params_all.legend.paddingLeft="200px";
		jQPlotOptionsLine_params_all.legend.placement="outsideGrid";
		//if(thisChart){thisChart.destroy(); 
		//}
	
	thisChart = $.jqplot('div-chart-1-content', [Points,Points1,Points2,Points3,Points4], jQPlotOptionsLine_params_all );
	//thisChart.redraw();
	//jqPlot().jqPlot();		

	});
	
	/*Points=new Array();
	//alert(chartDiv.id);
	Points.push(["01-01-1980",parseFloat(1.2)]);
	Points.push(["01-02-1980",parseFloat(2.2)]);
	Points.push(["01-03-1980",parseFloat(3.2)]);
	Points.push(["01-04-1980",parseFloat(1.2)]);*/
	

    
}






function drawChart_jgplot(lat,lon)
{
	var jQPlotOptionsLine_params=
    {    	
        title:'',
	    seriesDefaults: {
        showMarker: false
    },
    axesDefaults: {
        showTicks: true,
        showTickMarks: true,
		tickOptions: {
          angle: 30,
          fontSize: '8pt'
        }		
    },
	 series:[{showMarker:false}],
	 seriesColors:['#000080', '#800000'],
	  axes:{
        xaxis:{
          renderer:$.jqplot.DateAxisRenderer,
          tickOptions:{//formatString:'%d%m%y %H:%M',
		  formatString: '%Y',//'%d%b %H:%M',
         
		  },
		  //min:210613 14:00,
                 // tickInterval:'24 hour',
		  /*label: 'Time',*/
                  /* numberTicks: 10,*/
		   angle:30
        }
      },//axes
        
        highlighter: {
        show: true,
        sizeAdjust: 3,
      },
      cursor: {
        show: false
      },
	  
	legend: {
     show: true,
     placement: 'outside',
	 marginLeft:30,
	 marginRight:10
    } 

  
     };
	
	url="http://localhost/sheremed/request_netCDF_1.php?lat="+lat+"&lon="+lon;
		var jqxhrPlotRequest = $.post(url);
	
	jqxhrPlotRequest.done(function(data){
		
		//alert(data);
		console.log(data);
		var data_plt=$.parseJSON(data);
		console.log(data_plt);
		console.log(data_plt["row"][1]);
		//alert(data_plt["row"].length)
		Points=new Array();
		
		j=0;
		while(j<data_plt["row"].length)
        {		 
			 //alert(data_plt["row"][j].date+" "+data_plt["row"][j].val);
			if(data_plt["row"][j]) 
	           {Points.push([data_plt["row"][j].date,parseFloat(data_plt["row"][j].val)]);}
		   j=j+1;
        }	

	//jQPlotOptionsLine_params.series=[{label:'years'}];
	jQPlotOptionsLine_params.series=[{label:' '}];
	
	var thisChart = $.jqplot('div-chart-1-content', [Points], jQPlotOptionsLine_params );
	//jqPlot().jqPlot();		

	});
	
	/*Points=new Array();
	//alert(chartDiv.id);
	Points.push(["01-01-1980",parseFloat(1.2)]);
	Points.push(["01-02-1980",parseFloat(2.2)]);
	Points.push(["01-03-1980",parseFloat(3.2)]);
	Points.push(["01-04-1980",parseFloat(1.2)]);*/
	

    
}







/**
 * creates the chart without series
 * @param element - element in which the chart will be drawn
 * @param title - title of the chart
 * @param fileName - filename for downloaded chart
 * @return thisChart - a Highcharts chart object
 */
 
 
 
function drawChart(element, title, fileName)
{
    // create chart in element 
    var thisChart = Highcharts.chart(element,
    {
        title: {
            text: title
        },
        exporting: {
            buttons: {
                contextButton: {
                    _titleKey: "myKey",
                    menuItems: [{
                        text: 'Toggle full screen',
                        onclick: function () {
                            this.fullscreen.toggle();
                        }
                    },{
                        text: 'Download PNG image',
                        onclick: function () {
                            this.exportChart({
                                type: 'image/png',
                                filename: fileName
                            },{
                                title: {
                                    text: title,
                                    style: {
                                        lineHeight: 24
                                    }
                                },
                                subtitle: {
//                                    text: formatChartDateTime(new Date(this.series[0].xData[0]))+" to "+
//                                            formatChartDateTime(new Date(this.series[0].xData[this.series[0].xData.length-1])),
//                                    style: {
//                                        lineHeight: 14,
//                                        fontSize: '12px'
//                                    }
                                },
                                chart: {
                                    events: {
                                        load: function () {
//                                            this.renderer.image('/SHME.e45a91d1.png', 20, 400, 240, 38).add();
                                        }
                                    }
                                }
                            });
                        }
                    }, {
                        text: 'Download JPEG image',
                        onclick: function () {
                            this.exportChart({
                                type: 'image/jpeg',
                                filename: fileName
                            },{
                                title: {
                                    text: title,
                                    style: {
                                        lineHeight: 24
                                    }
                                },
                                subtitle: {
//                                    text: formatChartDateTime(new Date(this.series[0].xData[0]))+" to "+
//                                            formatChartDateTime(new Date(this.series[0].xData[this.series[0].xData.length-1])),
//                                    style: {
//                                        lineHeight: 14,
//                                        fontSize: '12px'
//                                    }
                                },
                                chart: {
                                    events: {
                                        load: function () {
//                                            this.renderer.image(BaseURL+'/assets/img/news-um-logos.jpg', 20, 400, 240, 38).add();
                                        }
                                    }
                                }
                            });
                        }
                    }, {
                        text: 'Download PDF document',
                        onclick: function () {
                            this.exportChart({
                                type: 'application/pdf',
                                filename: fileName
                            },{
                                title: {
                                    text: title,
                                    style: {
                                        lineHeight: 24
                                    }
                                },
                                subtitle: {
//                                    text: formatChartDateTime(new Date(this.series[0].xData[0]))+" to "+
//                                            formatChartDateTime(new Date(this.series[0].xData[this.series[0].xData.length-1])),
//                                    style: {
//                                        lineHeight: 14,
//                                        fontSize: '12px'
//                                    }
                                },
                                chart: {
                                    events: {
                                        load: function () {
//                                            this.renderer.image(BaseURL+'/assets/img/news-um-logos.jpg', 20, 400, 240, 38).add();
                                        }
                                    }
                                }
                            });
                        }
                    }]
                }
            }
        },
        yAxis: {
            id: 'default'
        }
    });
    
    return thisChart;
}

/**
 * get the series data from each of the requested sources and adds the series
 * to the latest chart
 * @param item - the data source for which data is requested
 * @param index - index of data source in array of data sources
 */
 
 
 
function getDataFromDatabase(item, index)
{
    // prepare query
    switch(item)
    {
        case SourceEnum.GozoWaveBuoy:
            query = "SELECT * FROM buoydata WHERE timestamp >= '"+
                    queryStart+"' AND timestamp <= '"+
                    queryEnd+"' ORDER BY timestamp";
            break;
        case SourceEnum.SicilyWaveBuoy:
            query = "SELECT * FROM buoydata_sicily WHERE timestamp >= '"+
                    queryStart+"' AND timestamp <= '"+
                    queryEnd+"' ORDER BY timestamp";
            break;
        case SourceEnum.MrxbSeaLevel:
            query = "SELECT * FROM data_marine_mrxb WHERE date_time >= '"+
                    queryStart+"' AND date_time <= '"+
                    queryEnd+"' ORDER BY date_time";
            break;
        case SourceEnum.DlmsSeaLevel:
            query = "SELECT * FROM data_marine_dlms WHERE date_time >= '"+
                    queryStart+"' AND date_time <= '"+
                    queryEnd+"' ORDER BY date_time";
            break;
        case SourceEnum.SnglSeaLevel:
            query = "SELECT * FROM data_marine_sngl WHERE date_time >= '"+
                    queryStart+"' AND date_time <= '"+
                    queryEnd+"' ORDER BY date_time";
            break;
    }
    
    // get data for charts from database
    $.ajax({
        url: PortoDataBase,
        type: "post",
        dataType: "json",
        data: ({query: query, source: item}),
        success: function(data){
            if (data==="No data")
            {
                
            }
            else
            {
                // go through each record and update timeline and data fields
                for (var i=0;i<data.length;i++)
                {
                    // get time stamp
                    timeLine[index].push(new Date(data[i][TimeField[item]]).getTime());

                    // get all the parameters
                    for (var j=0; j<SrcFieldMapping[item].length; j++)
                    {
                        dataSeries[index][j].push(parseFloat(data[i][SrcFieldMapping[item][j]]));
                    }
                }
            }
            
            // use data to create series for the chart
            for (var i=0; i<metaData[index].length; i++)
            {
                // if parameter has been selected add series to chart
                if (selectedParams.indexOf(metaData[index][i])>=0)
                {
                    var chartType, data;

                    // determine whether to add spline or scatter (for direction)
                    if (metaData[index][i] === ParamEnum.WaveDir)
                    {
                        chartType = 'scatter';
                    }
                    else
                    {
                        chartType = 'spline';
                    }
                
                    // create array of [x,y] pairs to plot on chart
                    data = merge2TimeSeriesArrayValidate(dataSeries[index][i], 
                                    timeLine[index], MinMapping[activeSources[index]][i], 
                                    MaxMapping[activeSources[index]][i]);
                                    
                    // increment series count for this chart
                    seriesCount[currentOpt]++;
                    
                    // add series to the current chart
                    charts[currentOpt].addSeries({
                        type: chartType,
                        name: TitleMapping[item][metaData[index][i]]+" from "+SourceName[item],
                        data: data,
                        color: Highcharts.getOptions().colors[seriesCount[currentOpt]],
                        tooltip: {
                            headerFormat:"<b>"+TitleMapping[item][metaData[index][i]]+" from "+SourceName[item]+"</b><br>",
                            pointFormat: "{point.x:%d %b %Y %H:%M}<br>{point.y:.1f} "+UnitsMapping[index][i]
                        },
                    });
                    
//                    // change the y-axis title
//                    if (i===2)
//                    {
                        charts[currentOpt].yAxis[0].setTitle({
                            text: TitleMapping[item][metaData[index][i]]+"<br>"+
                                                        UnitsMapping[item][metaData[index][i]],
                            opposite: (i%2===0)?false:true
                        });
                        
//                    }
//                    else
//                    {
//                        charts[currentOpt].addAxis({
//                            title: {
//                                text: TitleMapping[item][metaData[index][i]]+"<br>"+
//                                                        UnitsMapping[item][metaData[index][i]]
//                            },
//                            opposite: (i%2===0)?false:true
//                        });
//                    }
                }
            }
        }
    });
}

/**
 * opens a window to show chart with time series of selected parameters
 */
 
 
function openChartDiv(lat,lon)
{
    //drawChart_jgplot();
	currentOpt = $("input[name='option']:checked").val();
	//alert(currentOpt);
    
    // record settings
    chartSettings.push({
        sources: activeSources,
        start: queryStart,
        end: queryEnd,
        params: selectedParams,
        option: currentOpt
    });
    
    // increment number of open charts
    openCharts++;
    
    // create draggable div
	//alert(openCharts);
    var chartDiv = document.createElement('div');
    chartDiv.id = 'div-chart-'+openCharts;
    chartDiv.className = 'param-chart draggable ui-widget-content';  
    chartDiv.style.left = (120*(openCharts))+'px';
    chartDiv.style.top = (80*(openCharts))+'px';
    chartDiv.style.position = 'absolute';
    chartDiv.style.zIndex = '2000';
   // chartDiv.style.width = '640px';
    chartDiv.style.width = '800px';
        
    // create header for draggable div
    var chartHeader = document.createElement('div');
    chartHeader.id = 'div-chart-'+openCharts+'-header';
    chartHeader.className = 'param-header';
    chartHeader.style.cursor = 'move';
    chartHeader.style.paddingLeft = '9px';
    chartHeader.style.width = '90%';//'100%';
    chartHeader.innerHTML = "<b>Atlas annual data at point ("+lat.toFixed(2)+","+lon.toFixed(2)+") </b>"+
            " <span style='right:8px; position:absolute; cursor:pointer;'"+
            " onclick='closeChartDiv("+openCharts+")'>&times;</span>";

    // create element to contain the chart
    var chartContent = document.createElement('div');
    chartContent.id = 'div-chart-'+openCharts+'-content';
    chartContent.className = 'param-content';
    chartContent.style.backgroundColor = '#ffffff';
    chartHeader.style.width = '90%';//'100%';
    
    // loading gif
    var wait = document.createElement('div');
    wait.id = 'loading-gif';
    wait.style.padding = "72px 192px";
    chartHeader.style.width = '90%';//'100%';
    var img = document.createElement('img');
    img.src = "loading.gif";
    wait.appendChild(img);
    chartContent.appendChild(wait);
    
    // add new elements to DOM
    chartDiv.appendChild(chartHeader);
    chartDiv.appendChild(chartContent);
    document.body.appendChild(chartDiv);
    //drawChart_jgplot(lat,lon);
	drawChart_jgplot_all_params(lat,lon);
    //createChartContent(openCharts);
        
    // make the div draggable
    $(function() {
        $('#div-chart-'+openCharts).draggable({
            containment: "window", 
            scroll: false,
                handle: $('#div-chart-'+openCharts+'-header'),
                drag: function(event, ui){
                    chartDiv.style.transform = null;
                }
        });
    });
    
    // add focus event
    $('#div-chart-'+openCharts).focus(function(){
        $(this).css("border", "2px solid black");
    });
    
    // add focus out event
    $('#div-chart-'+openCharts).focusout(function(){
        $(this).css("border", "none");
    });
	
	//drawChart_jgplot();
}



/**
 * Opens the point observations panel
 */ 
function openAtlasPanel()
{
		el1=document.createElement("p");
		el1.innerHTML = "<b>tryam!</b>";
		//layersPane.addWidgetElement(el1);
		console.log(el1);
		//console.log(layersPane);
		
		el2=document.getElementById('sidebar');
		el2.appendChild(el1);
		console.log(el2);
		alert(el2);
	
	//alert("openAtlasPanel()");
	//openChartDiv();
	//alert(isLayerSelected);
    // change console button function
    $('#pt-obs-btn').attr('onclick', 'closeAtlasPanel()');
	
	// check whether point observations content already exists
	//alert(typeof(AtlasContent));
	//alert(($('#atlas-panel')));
	el=document.getElementById('atlas-panel');
	//alert(el);
	console.log(el);
	//document.remove(el);
	if(el)
	{document.remove(el)}
    if (typeof(AtlasContent)!=='undefined')
    {
		//closeAtlasPanel();
		//if($('#atlas-parent'))
		//{
			
		//}
        AtlasContent=$('#atlas-parent').detach();
		$('#atlas-panel').css({opacity: 1.0, left:DefaultPos['left'], 
                top:DefaultPos['top']});
        $('#atlas-panel').outerWidth(OpenInfoSize['width']);
        AtlasContent.appendTo('#atlas-panel');

        // update panel height
        $('#atlas-panel').css('height', 'auto');
    }
    // otherwise create new content
    else
    {
        // create new div for panel
				//layersPane.addWidgetElement(newDiv);
		
        var newDiv = document.createElement('div'); 
        newDiv.id = "atlas-panel";
        newDiv.style.width = OpenInfoSize.width+"px";
        newDiv.style.height = "auto";
        newDiv.style.left = DefaultPos.left;
        newDiv.style.top = DefaultPos.top;
        newDiv.style.zIndex = FloatingZIndex;
        newDiv.style.position = "absolute";
        newDiv.style.opacity = "1.0";
        newDiv.style.backgroundColor = '#ffffff';

        // create container for contents
        var parentDiv = document.createElement('div'); 
        parentDiv.id = "atlas-parent";
        parentDiv.style.width = OpenInfoSize.width+"px";
        parentDiv.style.height = "auto";

        // create header for panel
        var headerDiv = document.createElement('h1'); 
        headerDiv.style.width = OpenInfoSize.width+"px";
        headerDiv.style.height = "auto";
        headerDiv.style.cursor = "move";
        headerDiv.innerHTML = "Atlas";

        // create close button
        var closeBtn = document.createElement('span');
        closeBtn.style.right = "4px";
        closeBtn.style.position = "absolute";
        closeBtn.style.cursor = "pointer";
        closeBtn.addEventListener("click", closeAtlasPanel);
        closeBtn.innerHTML = "&times;";

        headerDiv.appendChild(closeBtn);

        // create process accordion
        var accordionDiv = document.createElement('div');
        accordionDiv.id = "process-accordion";
        accordionDiv.className = "accordion";

        // create first section of accordion
        var sourceDiv = document.createElement('div');
        var sourceHeader = document.createElement('div');
        //sourceHeader.innerHTML = "<a data-toggle='collapse' href='#source-selection' "+
                    "style='text-decoration:none; padding-left:16px'>"+
                "Monitoring station"+
                "<span class='fas fa-caret-down' style='right:16px; position:absolute'>"+
                "</span></a>";
        //sourceDiv.appendChild(sourceHeader);

        var sourceBody = document.createElement("div");
        sourceBody.id = "source-selection";
        sourceBody.setAttribute("data-parent", "#process-accordion");
        sourceBody.className = "collapse show";
        sourceBody.style.paddingLeft = "24px";
		sourceBody.innerHTML= "<label><b>YEAR SELECTION</b></label><br>"+
			       "<select id='year_yearly'>"+
						"<option value='2019'>2019</option>"+
						"<option value='2018'>2018</option>"+
						"<option value='2017'>2017</option>"+
						"<option value='2016'>2016</option>"+
						"<option value='2015'>2015</option>"+

				   "</select>&nbsp<BR><br>"+
				   
				   "<label><b><i>CAT</b></i></label><br>"+
				   
			       "<select id='cat_yearly'>"+
						"<option value=''>without</option>"+
						"<option value='_cat1'>Cat1</option>"+
						"<option value='_cat2'>Cat2</option>"+
						"<option value='_cat3'>Cat3</option>"+
						"<option value='_cat4'>Cat4</option>"+

				   "</select>&nbsp<BR><br>";
				 /*  "<button id='atlas_select_monthly' type='button' class='btn btn-primary'"+
                "onclick=load_atlas_map_monthly($('#year_yearly').val()+','+$('#cat_yearly').val())>Atlas Map</button>";*/

        /*sourceBody.innerHTML = "NEWS Gozo wave buoy"+
                "<input type='checkbox' id='source-check-"+SourceEnum.GozoWaveBuoy+"'"+ 
                        "onchange='updateFilters(SourceEnum.GozoWaveBuoy)'"+
                        "style='right:24px; position:absolute'><br>"+
                "NEWS Sicily wave buoy"+
                "<input type='checkbox' id='source-check-"+SourceEnum.SicilyWaveBuoy+"'"+ 
                        "onchange='updateFilters(SourceEnum.SicilyWaveBuoy)'"+
                        "style='right:24px; position:absolute'><br>"+
                "PORTO Delimara station"+
                "<input type='checkbox' id='source-check-"+SourceEnum.DlmsSeaLevel+"'"+ 
                        "onchange='updateFilters(SourceEnum.DlmsSeaLevel)'"+
                        "style='right:24px; position:absolute'><br>"+
                "PORTO Marsaxlokk station"+
                "<input type='checkbox' id='source-check-"+SourceEnum.MrxbSeaLevel+"'"+ 
                        "onchange='updateFilters(SourceEnum.MrxbSeaLevel)'"+
                        "style='right:24px; position:absolute'><br>"+
                "PORTO Senglea station"+
                "<input type='checkbox' id='source-check-"+SourceEnum.SnglSeaLevel+"'"+ 
                        "onchange='updateFilters(SourceEnum.SnglSeaLevel)'"+
                        "style='right:24px; position:absolute'><br>";*/
        sourceDiv.appendChild(sourceBody);

        // create second section of accordion
       // var filterDiv = document.createElement('div');
       // var filterHeader = document.createElement('div');
       /* filterHeader.innerHTML = "<a data-toggle='collapse' href='#filter-console' "+
                    "style='text-decoration:none; padding-left:16px'>"+
                "Filters"+
                "<span class='fas fa-caret-down' style='right:16px; position:absolute'>"+
                "</span></a>";
        filterDiv.appendChild(filterHeader);*/

        /*var filterBody = document.createElement("div");
        filterBody.id = "filter-console";
        filterBody.setAttribute("data-parent", "#process-accordion");
        filterBody.className = "collapse";
        filterBody.innerHTML = "<div style='padding-left:16px'>"+
                "<label for='time-slider' id='time-label'>"+
                "Select start and end of period of interest"+
                "</label></div>"+
                "<table style='width: 100%'>"+
                "<tr><td style='width:40px'>"+
                "<img src='http://maps.google.com/mapfiles/ms/icons/blue-dot.png' alt='Start marker'>"+
                "</td><td  style='width:auto'>"+
                "<div id='time-slider'></div>"+
                "</td><td style='width:40px; padding-left:8px'>"+
                "<img src='http://maps.google.com/mapfiles/ms/icons/red-dot.png' alt='End marker'>"+
                "</td></tr></table>"+
                "<table style='width: 100%'>"+
                "<tr><td id='start-time' style='width:50%; text-align:left; padding-left:4px'>"+
                "</td><td id='end-time' style='width:50%; text-align:right; padding-right:4px'>"+
                "</td></tr></table><hr>"+
                "<label id='param-label' style='padding-left:16px'>"+
                "Select parameters to plot"+
                "</label>"+
                "<div id='param-section' style='padding-left:24px'>"+
                "Sea surface temperature"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.SeaTemp+"'"+ 
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.SeaTemp)' "+
                "style='right:24px; position:absolute'><br>"+
                "Significant wave height"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.SWH+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.SWH)' "+
                "style='right:24px; position:absolute'><br>"+
                "Wave direction"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.WaveDir+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.WaveDir)' "+
                "style='right:24px; position:absolute'><br>"+
                "Dominant wave period"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.WavePeakPer+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.WavePeakPer)' "+
                "style='right:24px; position:absolute'><br>"+
                "Average wave period"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.WaveMeanPer+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.WaveMeanPer)') "+
                "style='right:24px; position:absolute'><br>"+
                "<br></div>";
        filterDiv.appendChild(filterBody);*/

        // create third section of accordion
        /*var optionsDiv = document.createElement('div');
        var optionsHeader = document.createElement('div');
        optionsHeader.innerHTML = "<a data-toggle='collapse' href='#options-selection' "+
                    "style='text-decoration:none; padding-left:16px'>"+
                "Other options"+
                "<span class='fas fa-caret-down' style='right:16px; position:absolute'>"+
                "</span></a>";
        optionsDiv.appendChild(optionsHeader);

        var optionsBody = document.createElement("div");
        optionsBody.id = "options-selection";
        optionsBody.setAttribute("data-parent", "#process-accordion");
        optionsBody.className = "collapse";
        optionsBody.style.paddingLeft = "24px";
        optionsBody.innerHTML = "Values"+
                "<input type='radio' id='option-radio-"+OptionEnum.Values+"' "+ 
                "name='option' value='"+OptionEnum.Values+"'"+
                "style='right:24px; position:absolute'>"+
                "<br>Difference"+
                "<input type='radio' id='option-radio-"+OptionEnum.Difference+"' "+ 
                "name='option' value='"+OptionEnum.Difference+"'"+
                "style='right:24px; position:absolute'>"+
                "<br>";
        optionsDiv.appendChild(optionsBody);*/
        
        // add sections to accordion 
        accordionDiv.appendChild(sourceDiv);
        //accordionDiv.appendChild(filterDiv);
        //accordionDiv.appendChild(optionsDiv);
        
        // create button div for panel
       /* var buttonDiv = document.createElement('div'); 
        buttonDiv.style.width = OpenInfoSize.width+"px";
        buttonDiv.style.height = "auto";
        buttonDiv.style.textAlign = "left";
        buttonDiv.style.padding = "4px";
        buttonDiv.innerHTML = "<button type='button' id='add_map' class='btn btn-primary'"+
                "onclick='openChartDiv()'>Generate chart</button>";

        // append elements to body
        parentDiv.appendChild(headerDiv);
        parentDiv.appendChild(accordionDiv);
        parentDiv.appendChild(buttonDiv);
        newDiv.appendChild(parentDiv);
        document.body.appendChild(newDiv);*/
		
        // create button div OK for panel Map
       var buttonDivOK = document.createElement('div'); 
        buttonDivOK.style.width = (OpenInfoSize.width-5)+"px";
        buttonDivOK.style.height = "auto";
        buttonDivOK.style.textAlign = "center";
        buttonDivOK.style.padding = "5px";
		//alert($('#year_yearly').val()+$('#cat_yearly').val());

        buttonDivOK.innerHTML = "<button id='atlas_select_monthly' type='button' class='btn btn-primary'"+
                "onclick=load_atlas_map_yearly($('#year_yearly').val(),$('#cat_yearly').val())>Atlas Map</button>";
       
        // append elements to body
        parentDiv.appendChild(headerDiv);
        parentDiv.appendChild(accordionDiv);
		//parentDiv.appendChild(buttonDiv);
        parentDiv.appendChild(buttonDivOK);
        newDiv.appendChild(parentDiv);
        document.body.appendChild(newDiv);


		

        // make observations panel draggable
        $(function() {
            $('#point-observations-panel').draggable({
                containment: "document", 
                scroll: false,
                handle: $('#point-observations-parent > h1'),
                drag: function(event, ui){
                        $('#point-observations-panel').css('transition', '0s');
                },
                stop: function(event, ui){
                        $('#point-observations-panel').css('transition', '0.5s');
                }
            });
        });

        // implement time slider
        $( function() {
            $( "#time-slider" ).slider({
                range: true,
                min: dateStart,
                max: dateEnd,
                step: 1,
                values: [dateStart, dateEnd],
                slide: function(event, ui) 
                {
                    // if date has been initialised
                    if (dateStart > 0)
                    {
                        // change date of start and end of path
                        var curStart = dateStart+(ui.values[0]*DayInMillis);
                        var curEnd = dateStart+(ui.values[1]*DayInMillis);
                        $('#start-time').text(new Date(curStart).toISOString().slice(0,10).replace('T', ' '));
                        $('#end-time').text(new Date(curEnd).toISOString().slice(0,10).replace('T', ' '));
                    }
                    // else leave blank
                    else
                    {
                        $('#start-time').text("");
                        $('#end-time').text("");
                    }
                },
                stop: function(event, ui)
                {
                    // if date has been initialised
                    if (dateStart > 0)
                    {
                        // set start and end time of query
                        var curStart = dateStart+(ui.values[0]*DayInMillis);
                        var curEnd = dateStart+(ui.values[1]*DayInMillis);
                        queryStart = new Date(curStart).toISOString().slice(0,10).replace('T', ' ');
                        queryEnd = new Date(curEnd+DayInMillis).toISOString().slice(0,10).replace('T', ' ');
                        $('#start-time').text(new Date(curStart).toISOString().slice(0,10).replace('T', ' '));
                        $('#end-time').text(new Date(curEnd).toISOString().slice(0,10).replace('T', ' '));
                    }
                    // else leave blank
                    else
                    {
                        $('#start-time').text("");
                        $('#end-time').text("");
                    }
                }
            });
        });
		
		/*layersPane.addWidgetElement(newDiv);
		el1=document.createElement("p");
		el1.innerHTML("<b>tryam!</b>");
		layersPane.addWidgetElement(el1);*/
		
    }
    
    // show location of stations on map
 /*   const source = new VectorSource();
    
    for (var i=0; i<SourceEnum.length; i++)
    {
        const coords = fromLonLat(SourceCoords[i]);
        
        console.log(coords);
    
        stations.push(new Feature(
        {
            geometry: new Point(coords)
        }));
    }
    
    source.addFeatures(stations);*/
}



function openAtlasPanel_monthly()
{
	//alert("openAtlasPanel()");
	//alert(isLayerSelected);
    // change console button function
    $('#pt-obs-btn').attr('onclick', 'closeAtlasPanel()');
	
	// check whether point observations content already exists
    if (typeof(AtlasContent)!=='undefined')
    {
		closeAtlasPanel();
		//AtlasContent=$('#atlas-parent').detach();
       /* $('#atlas-panel').css({opacity: 1.0, left:DefaultPos['left'], 
                top:DefaultPos['top']});
        $('#atlas-panel').outerWidth(OpenInfoSize['width']);
        AtlasContent.appendTo('#atlas-panel');

        // update panel height
        $('#atlas-panel').css('height', 'auto');*/
    }
    // otherwise create new content
    else
    {
        // create new div for panel
        var newDiv = document.createElement('div'); 
        newDiv.id = "atlas-panel";
        newDiv.style.width = OpenInfoSize.width+"px";
        newDiv.style.height = "auto";
        newDiv.style.left = DefaultPos.left;
        newDiv.style.top = DefaultPos.top;
        newDiv.style.zIndex = FloatingZIndex;
        newDiv.style.position = "absolute";
        newDiv.style.opacity = "1.0";
        newDiv.style.backgroundColor = '#ffffff';

        // create container for contents
        var parentDiv = document.createElement('div'); 
        parentDiv.id = "atlas-parent";
        parentDiv.style.width = OpenInfoSize.width+"px";
        parentDiv.style.height = "auto";

        // create header for panel
        var headerDiv = document.createElement('h1'); 
        headerDiv.style.width = OpenInfoSize.width+"px";
        headerDiv.style.height = "auto";
        headerDiv.style.cursor = "move";
        headerDiv.innerHTML = "Atlas";

        // create close button
        var closeBtn = document.createElement('span');
        closeBtn.style.right = "4px";
        closeBtn.style.position = "absolute";
        closeBtn.style.cursor = "pointer";
        closeBtn.addEventListener("click", closeAtlasPanel);
        closeBtn.innerHTML = "&times;";

        headerDiv.appendChild(closeBtn);

        // create process accordion
        var accordionDiv = document.createElement('div');
        accordionDiv.id = "process-accordion";
        accordionDiv.className = "accordion";

        // create first section of accordion
        var sourceDiv = document.createElement('div');
        var sourceHeader = document.createElement('div');
        //sourceHeader.innerHTML = "<a data-toggle='collapse' href='#source-selection' "+
                    "style='text-decoration:none; padding-left:16px'>"+
                "Monitoring station"+
                "<span class='fas fa-caret-down' style='right:16px; position:absolute'>"+
                "</span></a>";
        //sourceDiv.appendChild(sourceHeader);

        var sourceBody = document.createElement("div");
        sourceBody.id = "source-selection";
        sourceBody.setAttribute("data-parent", "#process-accordion");
        sourceBody.className = "collapse show";
        sourceBody.style.paddingLeft = "24px";
		sourceBody.innerHTML= "<label><b>YEAR </b></label>&nbsp&nbsp&nbsp&nbsp&nbsp<label><b>MONTH </b></label><br>"+
			       "<select id='year_monthly'>"+
						"<option value='2019'>2019</option>"+
						"<option value='2018'>2018</option>"+
						"<option value='2017'>2017</option>"+
						"<option value='2016'>2016</option>"+
						"<option value='2015'>2015</option>"+

				   "</select>&nbsp&nbsp&nbsp&nbsp&nbsp"+
				   
			       "<select id='month_monthly'>"+
						"<option value='1'>Jan</option>"+
						"<option value='2'>Feb</option>"+
						"<option value='3'>March</option>"+
						"<option value='4'>Apr</option>"+
						"<option value='5'>May</option>"+
						"<option value='6'>Jun</option>"+
						"<option value='7'>Jul</option>"+
						"<option value='8'>Aug</option>"+						
						"<option value='9'>Sep</option>"+
						"<option value='10'>Oct</option>"+
						"<option value='11'>Nov</option>"+						
						"<option value='12'>Dec</option>"+	
				   "</select>&nbsp<br><br>"+				   
				   
				   "<label><b><i>CAT</b></i></label><br>"+
				   
			       "<select id='cat_monthly'>"+
						"<option value=''>without</option>"+
						"<option value='_cat1'>Cat1</option>"+
						"<option value='_cat2'>Cat2</option>"+
						"<option value='_cat3'>Cat3</option>"+
						"<option value='_cat4'>Cat4</option>"+

				   "</select>&nbsp<BR><br>";
				 /*  "<button id='atlas_select_monthly' type='button' class='btn btn-primary'"+
                "onclick=load_atlas_map_monthly($('#year_yearly').val()+','+$('#cat_yearly').val())>Atlas Map</button>";*/

        /*sourceBody.innerHTML = "NEWS Gozo wave buoy"+
                "<input type='checkbox' id='source-check-"+SourceEnum.GozoWaveBuoy+"'"+ 
                        "onchange='updateFilters(SourceEnum.GozoWaveBuoy)'"+
                        "style='right:24px; position:absolute'><br>"+
                "NEWS Sicily wave buoy"+
                "<input type='checkbox' id='source-check-"+SourceEnum.SicilyWaveBuoy+"'"+ 
                        "onchange='updateFilters(SourceEnum.SicilyWaveBuoy)'"+
                        "style='right:24px; position:absolute'><br>"+
                "PORTO Delimara station"+
                "<input type='checkbox' id='source-check-"+SourceEnum.DlmsSeaLevel+"'"+ 
                        "onchange='updateFilters(SourceEnum.DlmsSeaLevel)'"+
                        "style='right:24px; position:absolute'><br>"+
                "PORTO Marsaxlokk station"+
                "<input type='checkbox' id='source-check-"+SourceEnum.MrxbSeaLevel+"'"+ 
                        "onchange='updateFilters(SourceEnum.MrxbSeaLevel)'"+
                        "style='right:24px; position:absolute'><br>"+
                "PORTO Senglea station"+
                "<input type='checkbox' id='source-check-"+SourceEnum.SnglSeaLevel+"'"+ 
                        "onchange='updateFilters(SourceEnum.SnglSeaLevel)'"+
                        "style='right:24px; position:absolute'><br>";*/
        sourceDiv.appendChild(sourceBody);

        // create second section of accordion
       // var filterDiv = document.createElement('div');
       // var filterHeader = document.createElement('div');
       /* filterHeader.innerHTML = "<a data-toggle='collapse' href='#filter-console' "+
                    "style='text-decoration:none; padding-left:16px'>"+
                "Filters"+
                "<span class='fas fa-caret-down' style='right:16px; position:absolute'>"+
                "</span></a>";
        filterDiv.appendChild(filterHeader);*/

        /*var filterBody = document.createElement("div");
        filterBody.id = "filter-console";
        filterBody.setAttribute("data-parent", "#process-accordion");
        filterBody.className = "collapse";
        filterBody.innerHTML = "<div style='padding-left:16px'>"+
                "<label for='time-slider' id='time-label'>"+
                "Select start and end of period of interest"+
                "</label></div>"+
                "<table style='width: 100%'>"+
                "<tr><td style='width:40px'>"+
                "<img src='http://maps.google.com/mapfiles/ms/icons/blue-dot.png' alt='Start marker'>"+
                "</td><td  style='width:auto'>"+
                "<div id='time-slider'></div>"+
                "</td><td style='width:40px; padding-left:8px'>"+
                "<img src='http://maps.google.com/mapfiles/ms/icons/red-dot.png' alt='End marker'>"+
                "</td></tr></table>"+
                "<table style='width: 100%'>"+
                "<tr><td id='start-time' style='width:50%; text-align:left; padding-left:4px'>"+
                "</td><td id='end-time' style='width:50%; text-align:right; padding-right:4px'>"+
                "</td></tr></table><hr>"+
                "<label id='param-label' style='padding-left:16px'>"+
                "Select parameters to plot"+
                "</label>"+
                "<div id='param-section' style='padding-left:24px'>"+
                "Sea surface temperature"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.SeaTemp+"'"+ 
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.SeaTemp)' "+
                "style='right:24px; position:absolute'><br>"+
                "Significant wave height"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.SWH+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.SWH)' "+
                "style='right:24px; position:absolute'><br>"+
                "Wave direction"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.WaveDir+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.WaveDir)' "+
                "style='right:24px; position:absolute'><br>"+
                "Dominant wave period"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.WavePeakPer+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.WavePeakPer)' "+
                "style='right:24px; position:absolute'><br>"+
                "Average wave period"+
                "<input type='checkbox' id='param-checkbox-"+ParamEnum.WaveMeanPer+"'"+
                "class='level-3-layers' disabled "+
                "onchange='updateParamList(ParamEnum.WaveMeanPer)') "+
                "style='right:24px; position:absolute'><br>"+
                "<br></div>";
        filterDiv.appendChild(filterBody);*/

        // create third section of accordion
        /*var optionsDiv = document.createElement('div');
        var optionsHeader = document.createElement('div');
        optionsHeader.innerHTML = "<a data-toggle='collapse' href='#options-selection' "+
                    "style='text-decoration:none; padding-left:16px'>"+
                "Other options"+
                "<span class='fas fa-caret-down' style='right:16px; position:absolute'>"+
                "</span></a>";
        optionsDiv.appendChild(optionsHeader);

        var optionsBody = document.createElement("div");
        optionsBody.id = "options-selection";
        optionsBody.setAttribute("data-parent", "#process-accordion");
        optionsBody.className = "collapse";
        optionsBody.style.paddingLeft = "24px";
        optionsBody.innerHTML = "Values"+
                "<input type='radio' id='option-radio-"+OptionEnum.Values+"' "+ 
                "name='option' value='"+OptionEnum.Values+"'"+
                "style='right:24px; position:absolute'>"+
                "<br>Difference"+
                "<input type='radio' id='option-radio-"+OptionEnum.Difference+"' "+ 
                "name='option' value='"+OptionEnum.Difference+"'"+
                "style='right:24px; position:absolute'>"+
                "<br>";
        optionsDiv.appendChild(optionsBody);*/
        
        // add sections to accordion 
        accordionDiv.appendChild(sourceDiv);
        //accordionDiv.appendChild(filterDiv);
        //accordionDiv.appendChild(optionsDiv);
        
        // create button div for panel
       /* var buttonDiv = document.createElement('div'); 
        buttonDiv.style.width = OpenInfoSize.width+"px";
        buttonDiv.style.height = "auto";
        buttonDiv.style.textAlign = "left";
        buttonDiv.style.padding = "4px";
        buttonDiv.innerHTML = "<button type='button' id='add_map' class='btn btn-primary'"+
                "onclick='openChartDiv()'>Generate chart</button>";

        // append elements to body
        parentDiv.appendChild(headerDiv);
        parentDiv.appendChild(accordionDiv);
        parentDiv.appendChild(buttonDiv);
        newDiv.appendChild(parentDiv);
        document.body.appendChild(newDiv);*/
		
        // create button div OK for panel Map
       var buttonDivOK = document.createElement('div'); 
        buttonDivOK.style.width = (OpenInfoSize.width-5)+"px";
        buttonDivOK.style.height = "auto";
        buttonDivOK.style.textAlign = "center";
        buttonDivOK.style.padding = "5px";
		//alert($('#year_yearly').val()+$('#cat_yearly').val());

        buttonDivOK.innerHTML = "<button id='atlas_select_monthly' type='button' class='btn btn-primary'"+
                "onclick=load_atlas_map_monthly($('#year_monthly').val(),$('#cat_monthly').val(),$('#month_monthly').val())>Atlas Map</button>";
       
        // append elements to body
        parentDiv.appendChild(headerDiv);
        parentDiv.appendChild(accordionDiv);
		//parentDiv.appendChild(buttonDiv);
        parentDiv.appendChild(buttonDivOK);
        newDiv.appendChild(parentDiv);
        document.body.appendChild(newDiv);		

        // make observations panel draggable
        $(function() {
            $('#point-observations-panel').draggable({
                containment: "document", 
                scroll: false,
                handle: $('#point-observations-parent > h1'),
                drag: function(event, ui){
                        $('#point-observations-panel').css('transition', '0s');
                },
                stop: function(event, ui){
                        $('#point-observations-panel').css('transition', '0.5s');
                }
            });
        });

        // implement time slider
        $( function() {
            $( "#time-slider" ).slider({
                range: true,
                min: dateStart,
                max: dateEnd,
                step: 1,
                values: [dateStart, dateEnd],
                slide: function(event, ui) 
                {
                    // if date has been initialised
                    if (dateStart > 0)
                    {
                        // change date of start and end of path
                        var curStart = dateStart+(ui.values[0]*DayInMillis);
                        var curEnd = dateStart+(ui.values[1]*DayInMillis);
                        $('#start-time').text(new Date(curStart).toISOString().slice(0,10).replace('T', ' '));
                        $('#end-time').text(new Date(curEnd).toISOString().slice(0,10).replace('T', ' '));
                    }
                    // else leave blank
                    else
                    {
                        $('#start-time').text("");
                        $('#end-time').text("");
                    }
                },
                stop: function(event, ui)
                {
                    // if date has been initialised
                    if (dateStart > 0)
                    {
                        // set start and end time of query
                        var curStart = dateStart+(ui.values[0]*DayInMillis);
                        var curEnd = dateStart+(ui.values[1]*DayInMillis);
                        queryStart = new Date(curStart).toISOString().slice(0,10).replace('T', ' ');
                        queryEnd = new Date(curEnd+DayInMillis).toISOString().slice(0,10).replace('T', ' ');
                        $('#start-time').text(new Date(curStart).toISOString().slice(0,10).replace('T', ' '));
                        $('#end-time').text(new Date(curEnd).toISOString().slice(0,10).replace('T', ' '));
                    }
                    // else leave blank
                    else
                    {
                        $('#start-time').text("");
                        $('#end-time').text("");
                    }
                }
            });
        });
    }
    
    // show location of stations on map
 /*   const source = new VectorSource();
    
    for (var i=0; i<SourceEnum.length; i++)
    {
        const coords = fromLonLat(SourceCoords[i]);
        
        console.log(coords);
    
        stations.push(new Feature(
        {
            geometry: new Point(coords)
        }));
    }
    
    source.addFeatures(stations);*/
}




/*
 * updates the filter console depending on the selected parameters
 * @param source - enumeration of the source being toggled
 */
function updateFilters(source)
{
    // update state variables according to source being toggled
    if ($('#source-check-'+source).is(':checked'))
    {
        // update state variable for active source
        activeSources.push(source);
        // update metadata and data arrays
        metaData.push(SrcParamMapping[source]);
        timeLine.push([]);
        dataSeries.push([]);
        for (var i=0; i<SrcParamMapping[source].length; i++)
        {
            // add arrays for each parameter 
            dataSeries[dataSeries.length-1].push([]);
        }
        
        // prepare query
        switch(source)
        {
            case SourceEnum.GozoWaveBuoy:
                query = "SELECT timestamp FROM buoydata order by timestamp LIMIT 1";
                break;
            case SourceEnum.SicilyWaveBuoy:
                query = "SELECT timestamp FROM buoydata_sicily order by timestamp LIMIT 1";
                break;
            case SourceEnum.MrxbSeaLevel:
                query = "SELECT date_time FROM data_marine_mrxb order by date_time LIMIT 1";
                break;
            case SourceEnum.DlmsSeaLevel:
                query = "SELECT date_time FROM data_marine_dlms order by date_time LIMIT 1;";
                break;
            case SourceEnum.SnglSeaLevel:
                query = "SELECT date_time FROM data_marine_sngl order by date_time LIMIT 1";
                break;
        }

        // post request to php script on server to get first date
        $.ajax({
            url: PortoDataBase,
            type: "POST",
            dataType:'json', // add json datatype to get json
            data: ({query: query, source: source}),
            success: function(data)
            {
                // set end time to now
                $('#end-time').text(new Date().toISOString().slice(0,10).replace('T', ' '));
                dateEnd = new Date($('#end-time').text()).getTime();
                var qryEnd = new Date().getTime()+DayInMillis;
                queryEnd = new Date(qryEnd).toISOString().slice(0,10).replace('T', ' ');
		
                // set start time to the earlier of existing or new timestamps
                var thisStart = new Date(data[0][0].slice(0,10)).getTime();
                timeSliderStart.push(thisStart);
				
		// set start time to earliest of start times 
                dateStart = Math.min(...timeSliderStart);
                $('#start-time').text(new Date(dateStart).toISOString().slice(0,10).replace('T', ' '));
                queryStart = $('#start-time').text();
				
		// get number of steps (days between start and stop)
                var steps = (dateEnd - dateStart)/DayInMillis;
				
		// set values on slider
                $('#time-slider').slider({
                    min: 0,
                    max: steps,
                    values: [0, steps]
                });
            }
        });
    }
    else
    {
        var ind = activeSources.indexOf(source);
        
        // remove source
        activeSources.splice(ind, 1);
        // remove timeslider settings for this source
        timeSliderStart.splice(ind, 1);
        // remove data and metadata
        metaData.splice(ind, 1);
        timeLine.splice(ind, 1);
        dataSeries.splice(ind, 1);
        
         // set end time to now
        $('#end-time').text(new Date().toISOString().slice(0,10).replace('T', ' '));
        dateEnd = new Date($('#end-time').text()).getTime();
        
        // set start time to earliest of start times 
        dateStart = Math.min(...timeSliderStart);
        $('#start-time').text(new Date(dateStart).toISOString().slice(0,10).replace('T', ' '));

        // get number of steps (days between start and stop)
        var steps = (dateEnd - dateStart)/DayInMillis;

        // set values on slider
        $('#time-slider').slider({
            min: 0,
            max: steps,
            values: [0, steps]
        });
    }
    
    // update the enabled parameter check boxes and create arrays for data series
    $('#param-section > input[type=checkbox]').attr('disabled', true);

    for(var i=0; i<activeSources.length; i++)
    {
        for(var j=0; j<SrcParamMapping[activeSources[i]].length; j++)
        {
            $('#param-checkbox-'+SrcParamMapping[activeSources[i]][j]).attr('disabled', false);
        }
    }
}

/*
 * updates the list of selected parameters depending on the selected checkboxes
 * @param param - enumeration of the param being toggled
 */
function updateParamList(param)
{
    if ($('#param-checkbox-'+param).is(':checked'))
    {
        selectedParams.push(param);
    }
    else
    {
        var ind = selectedParams.indexOf(param);
        
        selectedParams.splice(ind, 1);
    }
}

/*** Support functions ***/
/**
 * merge2TimeSeriesArray function
 * @param dataArray - array of values
 * @param timeArray - array of times corresponding to data as Date objects
 * @param minVal - minimum allowed value
 * @param maxVal - maximum allowed value
 * @returns array of data in json string as [Date, Float]
 */
function merge2TimeSeriesArrayValidate(dataArray, timeArray, minVal, maxVal)
{
    var timeSeries = [];
    var pts = dataArray.length;
    
    for (var i=0; i<pts; i++)
    {
        if ((dataArray[i]<=maxVal)&&(dataArray[i]>=minVal))
        {
            timeSeries.push([timeArray[i], dataArray[i]]);
        }
    }

    return timeSeries;
}

/*
function importScripts () {
  $("head").append($("<script></script>").attr("src", $(location).attr('href') + 'index.js'));

}*/
